'use client';
import React from 'react';
import SummaryLine from '@repo/ui/src/components/Cart/SummaryLine';
import type { CartTotals, CartSummaryExtra } from '@repo/ui/src/types/cart';

interface CartOrderSummaryProps {
  totals: CartTotals;
  extraLines?: Array<CartSummaryExtra>;
  /** Slot for app-specific promotional content (e.g. Traeger CMS markdown block). */
  promotionalNode?: React.ReactNode;
  subtotalLabel?: string;
  shippingLabel?: string;
  shippingFreeLabel?: string;
  taxLabel?: string;
  taxFreeLabel?: string;
  isCartPage?: boolean;
}

const CartOrderSummary = ({
  totals,
  extraLines,
  promotionalNode,
  subtotalLabel,
  shippingLabel = 'Shipping',
  shippingFreeLabel = 'Free',
  taxLabel = 'Estimated Tax',
  taxFreeLabel = '-',
  isCartPage = false,
}: CartOrderSummaryProps) => {
  const { subtotal, shippingTotal, tax, totalItems } = totals;

  const resolvedSubtotalLabel =
    subtotalLabel ?? `Subtotal (${totalItems} ${totalItems === 1 ? 'item' : 'items'})`;

  return (
    <div className="grid gap-y-2">
      <SummaryLine
        key="subtotal"
        bold={isCartPage}
        title={resolvedSubtotalLabel}
        value={subtotal}
      />
      <SummaryLine
        key="shipping"
        title={shippingLabel}
        value={shippingTotal}
        freeLabel={shippingFreeLabel}
      />
      <SummaryLine key="tax" title={taxLabel} value={tax} freeLabel={taxFreeLabel} />
      {extraLines?.map((line, i) => (
        <SummaryLine key={`extra-${i}`} title={line.label} value={line.value} />
      ))}
      {promotionalNode}
    </div>
  );
};

export default CartOrderSummary;
